import React from "react"
import DfbRte from "../ui-kit/dfb_rte"
import CHighlightArticles from "../elements/c_highlight_articles"
import PageContext from "../page-context"
import { t } from "../../i18n-utility"
import { getUsedRootCategoryIconTypes } from "../utilities"
import { useMultiFormatCollection } from "../../hooks/multiFormatCollection"
import Section from "./section"

const MAX_ICON_COUNT = 3
const MAX_TEASER_COUNT = 3

const MIntextTeaser = ({ data }) => {

  const {
    collection,
    text,
    sorting,
    tx_headless_selected_categories: categoriesFilter,
    tx_headless_selected_items: selectedItemIds,
  } = data
  let icons = undefined

  const highlightArticles = useMultiFormatCollection(
    collection,
    MAX_TEASER_COUNT,
    sorting,
    selectedItemIds
  )

  // when the list was filtered by category we add the first three
  if (categoriesFilter && highlightArticles && highlightArticles.length) {
    const categoryIds = categoriesFilter
      .split(/,\s*/)
      .map((idString) => (Number.parseInt(idString)))
    icons = getUsedRootCategoryIconTypes(highlightArticles, categoryIds).slice(0, MAX_ICON_COUNT)
  }

  return (
    <Section
      baseClass="m-IntextTeaser"
      data={data}
    >
      <div className="m-IntextTeaser-wrapper">
        <div className="m-IntextTeaser-container">
          <div className="m-IntextTeaser-row">
            {collection && !!collection.length && (
              <PageContext.Consumer>
                {({ translations }) => (
                  <CHighlightArticles data={{
                    title: t(translations, 'highlight_articles.headlines.related'),
                    icons: icons,
                    collection: highlightArticles,
                  }} />
                )}
              </PageContext.Consumer>
            )}
            <DfbRte text={text} />
          </div>
        </div>
      </div>
    </Section>
  )
}

export default MIntextTeaser
